@if(form!=null) {
  <form [formGroup]="form">
    <corp-control-title [corp-title]="corpLabel" [corp-size]="corpSize" [corp-disabled]="disabled"></corp-control-title>
    <div class="grid grid-cols-[auto_1fr] w-full border rounded overflow-hidden ring-1 ring-gray-200 focus-within:ring-2 focus-within:ring-primary-400">

        <corp-dropdown
          formControlName="selectPhone"
          [options]="countries">
        </corp-dropdown>

        <div class="relative w-full">
          <div class="absolute left-2 inset-y-0 flex items-center flex items-center gap-1 h-[42px] pointer-events-none">
                <span class="text-sm font-medium text-gray-600 ">
                ( + {{ form.get('selectPhone')?.value?.dialCode }} )
                </span>
          </div>
          <!-- formControlName="phone" -->
          <input
  formControlName="phone"
  (input)="onInput($event)"
  [placeholder]="mask"
  class="w-full h-[42px] pl-16 px-3 text-gray-900 border-0 outline-none focus:ring-0"
/>
         </div>

    </div>
  </form>
}
<!-- <form [formGroup]="form">
  <div class="grid grid-cols-[auto_1fr] w-full border rounded overflow-hidden focus-within:ring-2 focus-within:ring-primary-400">

  <corp-dropdown
    formControlName="selectPhone"
    [options]="countries"
    class="!border-0 !rounded-none">
  </corp-dropdown>

  <corp-input
    [corp-prefix]="'(+ ' + form.get('selectPhone')?.value?.dialCode + ')'"
    formControlName="phone"
    class="!border-0"
    placeholder="Phone number">
  </corp-input>

</div>
</form> -->
<!-- } -->
